// @ts-nocheck
import { TypographyPresentationProps } from "@insite/mobius/Typography";
import { css } from "styled-components";

export interface PageTitleProps {
    title: TypographyPresentationProps;
}

export const pageTitleProps: PageTitleProps = {
    title: {
        variant: "h1",
        css: css`
            font-weight: ${x => x.theme.design.typography.weight.extrabold};
            text-transform: uppercase;
        `,
    },
};
